/**
 * @fileoverview PATCH handler for the "/data_objects/:type_name/schema/fields/:field_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameSchemaFieldsFieldNameCacheKeys } from "./constants";
import type {
  PatchCustomObjectsTypeNameSchemaFieldsFieldNameProps,
  PatchCustomObjectsTypeNameSchemaFieldsFieldNameResult,
} from "./types";

export const patchCustomObjectsTypeNameSchemaFieldsFieldName = reactQueryMutationAdapter(
  [...customObjectsTypeNameSchemaFieldsFieldNameCacheKeys],
  ({
    appGroupId,
    typeName,
    fieldName,
    data_type,
    display_label,
    required,
  }: PatchCustomObjectsTypeNameSchemaFieldsFieldNameProps): Promise<PatchCustomObjectsTypeNameSchemaFieldsFieldNameResult> => {
    return fetch<PatchCustomObjectsTypeNameSchemaFieldsFieldNameResult>(
      `/data_objects/${encodeURIComponent(typeName)}/schema/fields/${encodeURIComponent(fieldName)}`,
      "PATCH",
      {
        app_group_id: appGroupId,
        data_type,
        display_label,
        required,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
